import { Badge } from '@/components/ui/badge';
import type { AdminOrganization } from '../services/adminApi';
import { orgProvisioningBadges } from './orgProvisioning';

/** "Terms: pending customer acceptance" and "Owner: none yet" for the org detail header (spec §7). */
export function OrgProvisioningBadges({
  org,
}: {
  org: Pick<AdminOrganization, 'customerTermsPending' | 'ownershipEstablished'>;
}) {
  const badges = orgProvisioningBadges(org);
  if (badges.length === 0) return null;
  return (
    <>
      {badges.map((badge) => (
        <Badge key={badge.key} variant="outline" className={badge.className} title={badge.title}>
          {badge.label}
        </Badge>
      ))}
    </>
  );
}
